angular.module('mtic').service('volumeCaptionStatus', function ($log) {

    //var eventManager = new EventManager('volumeCaptionStatus');
    var volumeOn = true;
    var captionsOn = false;

    // Public Methods
    var volumeCaptionStatus = {
        set: function(vol, capt){
            volumeOn = vol;
            captionsOn = capt;
        },

        getVolume: function(){
          return volumeOn;
        },
        getCaptions: function(){
          return captionsOn;
        },
    }


    return volumeCaptionStatus;
})
